import React from 'react';

const VideoIframe = props => {
    return (
        <video src={props.videoSrc} controls />
    );
}

export default VideoIframe